module.exports = __webpack_public_path__ + "img/2-3.98b39fa3.png";